export default "https://assets.egbcdn.net/assets/packs/_/images/app/apk/apk-2-80bbcc4cc444a7488dabca6e3dd9251a.png";